import React, { ReactNode } from 'react';

import { Box, Stack } from '@mui/material';

import { StyledTooltip } from '../StyledTooltip/StyledTooltip';

import { LeaderboardTooltipRow } from './LeaderboardTooltipRow';
import { LeaderboardRating } from './leaderboardTypes';

export const LeaderboardTooltip = ({ children, rating }: { children: ReactNode; rating?: LeaderboardRating }) => {
  const roundRating = (value: number) => {
    return Math.round(value * 10) / 10;
  };

  return (
    <StyledTooltip
      placement="right"
      title={
        <Stack spacing={2} width={140} p={3}>
          {rating?.metrics.map((metric) => (
            <LeaderboardTooltipRow title={metric?.name} value={roundRating(metric.score || 0)} />
          ))}
        </Stack>
      }
    >
      <Box>{children}</Box>
    </StyledTooltip>
  );
};
